import React from "react";
// import RouteViewPage from "../Pages/route-view-page";
import CleanupsPage from "../Pages/cleanups-page";
import { useParams } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import GetEvent from "../Drive/get-event";

function Quotes() {
  const data_sheet_id = "1m847yv_XQmm0K2UgoRiTXC6Ezh4r3dTAyc1luyyya08";
  const data_csv_url =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vRVKM_1pV_-To46tHpdGZc4SF35X-TxwAPlfAd2qe89qt6qppashP2y84IWaLoa9AzH6HwWL6wkKHQF/pub?output=csv";
  const script_id =
    "AKfycbzuFU7YyW1N4ZIRfCleR-C2I-ygfp2WSn_z1uFf5BuKx9b7LveyG42iZNFZW2AUUrcM";
  // ACTION: Change to this path requires update to public cleanup routes sheet getImages script
  const base_image_upload_path = "/uploads/${event}/${service}/properties/";
  const [image_upload_path, setImageUploadPath] = React.useState("");

  React.useEffect(() => {
    GetEvent(script_id, handleUpdateEvent);
  }, []);

  const handleUpdateEvent = (result) => {
    if (result.succeeded) {
      let newPath = base_image_upload_path.replace("${event}", result.event);
      setImageUploadPath(newPath);
    }
  };

  let params = useParams();
  let id = params.id.replaceAll("_", " ");

  return (
    <>
      {image_upload_path == "" ? (
        <LinearProgress />
      ) : (
        <CleanupsPage
          id={id}
          data_sheet_id={data_sheet_id}
          data_csv_url={data_csv_url}
          script_id={script_id}
          image_upload_path={image_upload_path}
          quote
        />
      )}
    </>
  );
}

export default Quotes;
